module.exports = __webpack_public_path__ + "img/bg_2.a13fa90b.png";